var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoreIconNavPanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5669 9.82043V13.6038C17.5669 16.2454 15.8752 18.0204 13.3502 18.0204H6.65026C4.12526 18.0204 2.43359 16.2454 2.43359 13.6038V9.82043C2.43359 7.35378 3.91693 5.64544 6.16693 5.42878C6.32526 5.42044 6.48359 5.41211 6.65026 5.41211H13.3502C13.5169 5.41211 13.6752 5.42044 13.8336 5.42878C16.0836 5.64544 17.5669 7.35378 17.5669 9.82043Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8337 5.42852C13.6753 5.42018 13.517 5.41185 13.3503 5.41185H12.567C12.367 4.17852 11.292 3.22852 10.0003 3.22852C8.70866 3.22852 7.63366 4.17852 7.43366 5.41185H6.65033C6.48366 5.41185 6.32533 5.42018 6.16699 5.42852C6.37533 3.48685 8.00866 1.97852 10.0003 1.97852C11.992 1.97852 13.6253 3.48685 13.8337 5.42852Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0007 12.3331C9.14156 12.3331 8.32659 11.9972 7.70742 11.3881C7.17992 10.8506 6.85492 10.1656 6.78159 9.45223C6.74659 9.1089 6.99659 8.80223 7.33992 8.76723C7.68076 8.7364 7.9891 8.98223 8.02493 9.32473C8.06993 9.75807 8.27076 10.1772 8.59239 10.5056C8.96822 10.8747 9.47072 11.0831 10.0007 11.0831C11.0149 11.0831 11.8641 10.3247 11.9774 9.3189C12.0166 8.97557 12.3316 8.72723 12.6682 8.76807C13.0107 8.8064 13.2574 9.11557 13.2191 9.45807C13.0357 11.0972 11.6516 12.3331 10.0007 12.3331Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreIconNavPanel);
export default __webpack_public_path__ + "static/media/store_icon_nav_panel.7bbe7e1ac51fa9e9f586f34d2f3bc686.svg";
export { ForwardRef as ReactComponent };